import { useState } from "react";
import classes from "./ADLogin.module.css";
import { useTranslation } from "react-i18next";
import LogoutModal from "./LogoutModal";

export const SignOutButton = () => {
  const { t } = useTranslation();
  const [showLogoutModal, setShowLogoutModal] = useState<boolean>(false);

  const handleOpenModal = () => {
    setShowLogoutModal(true);
  };

  const handleCloseModal = () => {
    setShowLogoutModal(false);
  };

  return (
    <>
      <div className={classes.logOut} onClick={handleOpenModal} color="inherit">
        {t("login.logoutADButtonText")}
      </div>

      {showLogoutModal && <LogoutModal onClose={handleCloseModal} />}
    </>
  );
};